import React from 'react';

export default function BarraBotones() {;
  return (
    <>
      <div className="btn-flotante" onClick={() => window.scrollTo(0, 0)}><i className="bi bi-arrow-up-short"></i></div>
    </>
  );
}
